import axios from 'axios';

// Get API configuration from environment
const API_BASE_URL = process.env.MIX_API_URL || 'V1/api';
const API_VERSION = process.env.MIX_API_VERSION || 'v1';

const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-API-Version': API_VERSION
    }
});

// Add CSRF token for Laravel
const csrfToken = document.querySelector('meta[name="csrf-token"]');
if (csrfToken) {
    axiosInstance.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken.content;
}

// Request interceptor
axiosInstance.interceptors.request.use(
    (config) => {
        // You can add auth token or other headers here
        const token = localStorage.getItem('auth_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        // Handle common errors
        if (error.response?.status === 401) {
            // Redirect to login or refresh token
            localStorage.removeItem('auth_token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;